import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-help',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './help.html',
  styleUrls: ['./help.scss']
})
export class HelpComponent implements OnInit {

  ngOnInit() {
    window.scrollTo(0, 0);
  }
}